import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import PCICLogo from '../../images/pcic-new-logo.jpg';

const HeaderS2 = (props) => {
    const [services, setServices] = useState([]);
    const [events, setEvents] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [servicesRes, eventsRes] = await Promise.all([
                    fetch('/api/services'),
                    fetch('/api/events')
                ]);
                const servicesData = await servicesRes.json();
                const eventsData = await eventsRes.json();
                setServices(Array.isArray(servicesData) ? servicesData : []);
                setEvents(Array.isArray(eventsData) ? eventsData : []);
            } catch (error) {
                console.error('Error fetching navigation data:', error);
            }
        };
        fetchData();
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <header id="header" className="header-s2">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home" style={{display: 'flex', alignItems: 'center', gap: '10px', padding: '5px 0'}}>
                                        <img src={PCICLogo} alt="PCIC Logo" style={{height: '55px', width: '55px', objectFit: 'contain', borderRadius: '6px'}} />
                                        <span style={{color: '#1B2324', fontSize: '22px', fontWeight: '700', letterSpacing: '0.5px', fontFamily: "'Poppins', sans-serif"}}>PCIC</span>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0" style={{flexWrap: 'nowrap'}}>
                                        <li>
                                            <Link onClick={ClickHandler} className="active" to="/">Home</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={(e) => e.preventDefault()} to="#">Services <i className="ti-angle-down"></i></Link>
                                            <ul className="sub-menu">
                                                {services.length > 0 ? (
                                                    services.map((service) => (
                                                        <li key={service.id}>
                                                            <Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>
                                                                {service.title}
                                                            </Link>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li><Link to="#">Loading...</Link></li>
                                                )}
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={(e) => e.preventDefault()} to="#">Events <i className="ti-angle-down"></i></Link>
                                            <ul className="sub-menu">
                                                {events.length > 0 ? (
                                                    events.map((event) => (
                                                        <li key={event.id}>
                                                            <Link onClick={ClickHandler} to={`/event-single/${event.slug}`}>
                                                                {event.title}
                                                            </Link>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li><Link to="#">Loading...</Link></li>
                                                )}
                                            </ul>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/about">About Us</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/wall-of-akhirah">Wall of Akhirah</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/contact">Contact Us</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="close-form">
                                        <Link onClick={ClickHandler} className="theme-btn" to="/donate">Donate now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}
const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};


export default connect(mapStateToProps, { removeFromCart })(HeaderS2);
